/**
 * Re-export speech hooks from btg-ai-agent for use in the Zaunplaner chatbot.
 */
export { useSpeechToText, useTextToSpeech, stripForSpeech } from "btg-ai-agent";
export type { SpeechToTextResult, TextToSpeechResult } from "btg-ai-agent";
